import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../shared/store';


interface IProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute= (props: IProtectedRouteProps) => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login with current location and query string
    return <Navigate to={`/login${location.search}`} state={{ from: location }} replace />;
  }

  return props.children;
};

export default ProtectedRoute;